/* eslint-disable react/prop-types */
import { Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import ModalUI from "components/ModalUI";
import SoftBadge from "components/SoftBadge";
import SoftButton from "components/SoftButton";
import ghollakProfitCalculationStatus from "enums/ghollakProfitCalculationStatus";
import useModal from "hooks/useModal";
import React, { useState } from "react";
import fixTableCellWidth from 'utils/fixTableCellWidth';
import separate from 'utils/separate';
import GhollakProfitProcessModal from "./GhollakProfitProcessModal";
import ProfitDetailModal from "./ProfitDetailModal";

function Row(props) {
    const { row, selected, onSelectCheckbox, updateModal } = props;

    return (
        <React.Fragment>
            <TableRow
                sx={{ "& > *": { borderBottom: "unset" }, backgroundColor: row.id % 2 === 1 ? "" : "rgba(204,204,204,0.1)" }}>
                <TableCell className="tablecell"><Checkbox checked={selected.includes(row.id)} onChange={(event) => onSelectCheckbox(event, row.id)} color='primary' /></TableCell>
                <TableCell className="tablecell" align="left" title={separate(Number(row.balance))}
                    style={fixTableCellWidth("150px")}>{separate(Number(row.balance).toFixed(0))}</TableCell>
                <TableCell className="tablecell" align="left" title={separate(Number(row.investment_opportunity_balance))}
                    style={fixTableCellWidth("150px")}>{separate(Number(row.investment_opportunity_balance).toFixed(0))}</TableCell>
                <TableCell className="tablecell" align="left" title={separate(Number(row.daily_interest))}
                    style={fixTableCellWidth("100px")}>{separate(Number(row.daily_interest).toFixed(0))}</TableCell>
                <TableCell className="tablecell" align="left"
                    style={fixTableCellWidth("100px")}>{row.locked ? 'بله' : 'خیر'}</TableCell>
                <TableCell className="tablecell" align="left"
                    style={fixTableCellWidth("110px")}>{new Date(row.for_date).toLocaleString("fa-IR").split(",")[0]}</TableCell>
                <TableCell className="tablecell" align="left"
                    style={fixTableCellWidth("110px")}>
                    <SoftBadge variant="contained" style={{ cursor: "pointer" }} onClick={() => row?.ghollak_profit_calculations && updateModal("profitDetail", { state: true, item: row?.ghollak_profit_calculations })}
                        badgeContent={ghollakProfitCalculationStatus(row?.ghollak_profit_calculations?.status)}
                        color={row?.ghollak_profit_calculations?.status === 102 ? 'success' : "secondary"} size="xs" />
                </TableCell>
            </TableRow>
        </React.Fragment>
    );
}
export default function GhollakCalculateDetailModal({ modalInfo, closeModal }) {
    const [minBalanceIds, setMinBalanceIds] = useState(modalInfo.item.items.filter(item => item?.ghollak_profit_calculations?.status !== 102)
        .map(item => item.id)
    );
    const [modals, updateModal, closeInsideModal] = useModal({
        profitProcess: { state: false },
        profitDetail: { state: false },
    });
    const closeProfitProcessModal = () => closeInsideModal("profitProcess");
    const closeProfitDetailModal = () => closeInsideModal("profitDetail");
    const handleSelectItem = (event, id) => {
        if (event.target.checked) {
            setMinBalanceIds((prev) => [...prev, id])
            return;
        }
        const idIndex = minBalanceIds.findIndex(item => item === id);
        setMinBalanceIds([...minBalanceIds.slice(0, idIndex), ...minBalanceIds.slice(idIndex + 1)]);
    };
    let totalGrossProfit = 0;
    let totalPlatformFee = 0;
    let totalUserProfit = 0;

    minBalanceIds.forEach(item => {
        let element = modalInfo.item.items.find(item2 => item2.id === item);
        if (element.ghollak_profit_calculations) {
            totalGrossProfit += parseFloat(element.ghollak_profit_calculations.gross_profit_amount);
            totalPlatformFee += parseFloat(element.ghollak_profit_calculations.platform_fee_amount);
            totalUserProfit += parseFloat(element.ghollak_profit_calculations.user_profit_amount);
        }
    });
    return (
        <ModalUI open={modalInfo.state} handleClose={closeModal} style={{ minWidth: "600px" }}>
            <TableContainer component={Paper}>
                <Table>
                    <SoftButton
                        size="small"
                        style={{ marginRight: 10 }}
                        onClick={() => updateModal('profitProcess', { state: true, minBalanceIds: minBalanceIds })}
                        variant="gradient"
                        color="info"
                    >
                        اعمال
                    </SoftButton>
                    <section>
                        {totalGrossProfit !== 0 && <SoftBadge variant="contained" color="success"
                            badgeContent={`مجموع سود ناخالص: ${separate(Number(totalGrossProfit).toFixed(0))} تومان`}
                            size="xs" />}
                        {totalUserProfit !== 0 && <SoftBadge variant="contained"
                            badgeContent={`مجموع سود کاربر: ${separate(Number(totalUserProfit).toFixed(0))} تومان`}
                            size="xs" />}
                        {totalPlatformFee !== 0 && <SoftBadge variant="contained" color="secondary"
                            badgeContent={`مجموع سهم پلتفرم: ${separate(Number(totalPlatformFee).toFixed(0))} تومان`}
                            size="xs" />}
                    </section>
                    <TableHead>
                        <TableRow>
                            <TableCell></TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>موجودی قلک</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("150px")}>موجودی فرصت</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("100px")}>سود روزانه</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("110px")}>قفل</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("110px")}>برای تاریخ</TableCell>
                            <TableCell className="tablecell" style={fixTableCellWidth("110px")}>وضعیت</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody style={{ display: "block" }}>
                        {modalInfo.item.items.map((row) => (
                            <Row key={row.id} row={row} selected={minBalanceIds} updateModal={updateModal} onSelectCheckbox={handleSelectItem} />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {modals.profitProcess.state && <GhollakProfitProcessModal modalInfo={modals.profitProcess} closeModal={closeProfitProcessModal} />}
            {modals.profitDetail.state && <ProfitDetailModal modalInfo={modals.profitDetail} closeModal={closeProfitDetailModal} />}
        </ModalUI>
    )
}